import axios from 'axios';
import { trim } from "lodash";
import moment from "moment";
import { useEffect, useReducer } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import validator from "validator";
import { useAuth } from '../../Context/AuthContext';
import useAxiosFetch from '../useAxiosFetch';
import useStateProvince from '../useStateProvince';
import useValidations from './useValidations';

const useProfileForm = () => {
  // api api from global hook 

  const { axiosFetch} = useAxiosFetch();
    const [countryList, stateList, getProvinceFunc] = useStateProvince();
const {isAvailableError,isMobileNumberError,isValidNumberError,isRequiredNumberError,isValidEmailError}=useValidations()


    const { designation } = useAuth();
    const { id: profileId } = useParams();
  
    const handleClose = () => dispatch({type:"modal_close",payload:{},name:"modal_close"});
    const handleShow = () =>  dispatch({type:"modal_show",payload:{},name:"modal_show"});
    const initialState = {
        first_name: "",
        middle_name: "",
        last_name: "",
        username: "",
        email: "",
        phone_number: "",
        address: "",
        apartment: "",
        city: "",
        province: "",
        country: "",
        postal_code: "",
        profile_image: {},
        status: true,
        AssignsData: [],
        worker_roles: "",
        nsf: "",
        internet: "",
        locker: "",
        parking: "",
        advance_rent: "",
        key_deposit: "",
        laundry_deposit: "",
        building_id: "",
        unit_id: "",
unit_type: "",
        monthly_rent: "",
        lease_start_date: "",
        lease_end_date: "",
    
        managerBuildingAssigns: [],
        buildinglist: [],
        unitlist: [],
        unitdetails: {},
        searchKeywords: "",
        errorMessage: {},
        taxInfo: {},
        loading: false,
        hydroInvoices: [{
          amount: "",
          month: "",
          hydro_img:{}
        },],
        makeUrl: {
            navigateUrl: "",
            apiUrl: "",
        },
        show:false ,
        payment_mode:""
    }

    const location = useLocation();
    const pathname = location.pathname;

  


    const updateProfile = (state, action) => {
   

  
        const {value={},name="",type=""}=action?.payload||{};
     
       
     

        switch (action.type) {
            case "set_loading":
                return { ...state , loading: action?.payload};
            case "find_user_role":
                return { ...state , makeUrl: action?.payload};
            case "load_profile_data":
                return { ...state   ,...action?.payload,managerBuildingAssigns:action?.payload?.AssignsData ,lease_end_date:action?.payload?.lease_end_date ? new Date(action?.payload?.lease_end_date) : null, lease_start_date:action?.payload?.lease_start_date ?  new Date(action?.payload?.lease_start_date) : null  ,profile_image:{url:action?.payload?.profile_image}};
            case "load_buildinglist":
                return { ...state , buildinglist: action?.payload};
            case "load_unitlist":
                return { ...state , unitlist: action?.payload};
            case "load_unit_details":
                return { ...state ,unit_part: action?.payload?.unit_part ,apartment_size:action?.payload?.apartment_size};
            case "load_tax_list":
                return { ...state ,...action?.payload , taxInfo: action?.payload};
            case "modal_close":
                return { ...state , show: false};
            case "modal_show":
                return { ...state , show: true};
            case "input":
                return { ...state ,errorMessage:{}, [name]: type=="checkbox" ? action.payload.checked ? true:false :  value};
            case "managerBuildingAssigns":
                return { ...state , managerBuildingAssigns:  action.payload.checked ? [...state?.managerBuildingAssigns,action?.itemId]:state?.managerBuildingAssigns.filter(it=>it !== action?.itemId)};
            case "file":
                return { ...state , [name]:{
                    name: action?.payload?.files[0].name,
                    url: URL.createObjectURL(action?.payload?.files[0]),
                    file: action?.payload?.files[0],
                  }};
                  case "set_error":
                return { ...state , errorMessage: action?.payload, loading:false};

                //* Hydro invocies
                case "ADD_hydroInvoice_FIELD":
                  return {
                    ...state,
                    hydroInvoices: [...state.hydroInvoices, { amount: "", month: "", hydro_img:{}}]
                  };
                case "REMOVE_hydroInvoice_FIELD":
                  return {
                    ...state,
                    hydroInvoices: state.hydroInvoices.filter(
                      (_, index) => index !== action.index
                    )
                  };
                case "UPDATE_INPUT_hydroInvoice_VALUE":
                  return {
                    ...state,
                    hydroInvoices: state.hydroInvoices.map((inputField, index) =>
                      index === action.index
                        ? { ...inputField, [name]:type=="file"?  {
                          name: action?.payload?.files[0].name,
                          url: URL.createObjectURL(action?.payload?.files[0]),
                          file: action?.payload?.files[0],
                        } :  value }
                        : inputField
                    )
                  };
            default:
                return state;

        }

    }
    const [profileState, dispatch] = useReducer(updateProfile, initialState);

    const {

        first_name,
        middle_name,
        last_name,
        username,
        email,
        phone_number,
        address,
        apartment,
        city,
        province,
        country,
        postal_code,
        profile_image,
        status,
        AssignsData,
        worker_roles,
        nsf,
        internet,
        locker,
        parking,
        advance_rent,
        key_deposit,
        laundry_deposit,
        building_id,
        unit_id,

        unit_type,
        monthly_rent,
        lease_start_date,
        lease_end_date,
       
        managerBuildingAssigns,
        buildinglist,
        unitlist,
        unitdetails,
        searchKeywords,
        errorMessage,
        loading,
        makeUrl ,
        show ,
        taxInfo ,
        hydroInvoices ,
        payment_mode
        
    } = profileState;



    useEffect(() => {
      

        if (pathname.includes("addpartner")) {
        dispatch({type:"find_user_role",payload:{ apiUrl: "partner", navigateUrl: "/partnerlist" }})

      
        }
        if (pathname.includes("manager")) {
            dispatch({type:"find_user_role",payload:{ apiUrl: "manager", navigateUrl: "/managerlist" }})
 
        }
        if (pathname.includes("accountant")) {
            dispatch({type:"find_user_role",payload:{ apiUrl: "accountant", navigateUrl: "/accountantlist" }})

   
        }
        if (pathname.includes("worker")) {
            dispatch({type:"find_user_role",payload:{ apiUrl: "worker", navigateUrl: "/workerlist" }})

     
        }
        if (pathname.includes("tenant")) {
            dispatch({type:"find_user_role",payload:{ apiUrl: "tenant", navigateUrl: "/tenantlist" }})

      
        }
      }, [pathname]);

      

  useEffect(() => {
    if (makeUrl.apiUrl == "manager" || makeUrl.apiUrl == "tenant") {
      searchBuilding()
    }

  }, [makeUrl, searchKeywords]);

  const searchBuilding = () => {

    axiosFetch({
      axiosInstance: axios,
      method: "post",
      url: "building/list",
      requestConfig: { search: searchKeywords },
     
    }).then((res) => {
        dispatch({type:"load_buildinglist",payload:res?.data?.result?.rows||[]})

     });

  }

   
  useEffect(() => {
    if (country) {

      getProvinceFunc(country)
    }
  }, [country])

  useEffect(() => {
    if (building_id) {
      axiosFetch({
        axiosInstance: axios,
        method: "post",
        url: `/unit/list/${building_id}`,
        requestConfig: {
          status: "Available",
          tenant_id: profileId
        },
      
      }).then(res=>{
        dispatch({type:"load_unitlist",payload:res?.data?.result?.rows||[]})

      })
    }
  }, [building_id]);

  useEffect(() => {
    if (unit_id) {
      axiosFetch({
        axiosInstance: axios,
        method: "GET",
        url: `/unit/show/${unit_id}`,
      }).then((res) => {
          
          axiosFetch({
              axiosInstance: axios,
              method: "post",
              url: "tax/show",
              requestConfig: { country: res?.data?.Building?.country , province: res?.data?.Building?.province }
              
            }).then(ress=>{
                dispatch({type:"load_tax_list",payload:ress?.data?.TaxDetails?.tax||{}})
                
                
            })
            dispatch({type:"load_unit_details",payload:res?.data})})

        
      
    }
  }, [unit_id]);


  const getProfileDetails = () => {
    axios
      .get(`/${makeUrl.apiUrl}/show/${profileId}`)
      .then((response) => {


        if (Object.keys(response?.data).length > 1) {

            dispatch({type:"load_profile_data",payload:response?.data})


       
        }

      })
      .catch((e) => { });
  };
  useEffect(() => {
    if (makeUrl.apiUrl && profileId) {
      getProfileDetails();
    }
  }, [profileId, makeUrl]);


  const validation = () => {
    const errors = {};
    const isGreaterDay = (d1, d2) => {
      var startDates = d1;
      var endDates = d2;
      if (startDates > endDates) {
        if (
          moment(new Date(null)).format("LLLL") ==
          moment(endDates).format("LLLL")
        ) {
          errors.lease_end_date = "Please enter your lease end date.";
          return true;
        }
        errors.lease_end_date = "End date can't be before start date";
        return true;
      }
      return false;
    };
    if (makeUrl.apiUrl == "worker") {
      if (!worker_roles || !trim(worker_roles)) {
        errors.worker_roles = "Please choose worker role.";
      }
    }
    if (makeUrl.apiUrl == "tenant") {

      if (!lease_start_date || !trim(lease_start_date)) {
        errors.lease_start_date = "Please enter your lease start date.";
      }
      if (!lease_end_date || !trim(lease_end_date)) {
        errors.lease_end_date = "Please enter your lease end date.";
      }

      if (isGreaterDay(new Date(lease_start_date), new Date(lease_end_date))) {
      }

    }


const requiredField=["first_name","username","address","city","province","country","postal_code"];


let requiredFieldValid=isAvailableError(requiredField,profileState)
const mobileValid=isMobileNumberError(["phone_number"],profileState);


     
    


const emailValid=isValidEmailError(["email"],profileState)
const numberNonRequiredValid=isValidNumberError(["key_deposit","advance_rent","laundry_deposit","nsf","locker","internet","parking"],profileState)

let isManthlyValidation={}
   


   






    if (makeUrl.apiUrl == "tenant") {

      requiredField.push("building_id","unit_id")
       requiredFieldValid=isAvailableError(requiredField,profileState)


 const isManthly= validator.isNumeric(`${profileState.monthly_rent}`) 
 
 isManthlyValidation=isManthly ? {} : {monthly_rent:"Please enter a valid your monthly_rent"}

     
    }



    return {...errors,...isManthlyValidation,...numberNonRequiredValid,...emailValid,...mobileValid,...requiredFieldValid};
  };

  const paymentOption = [
    {
      id: "1",
      name: "Interac",
    },
    {
      id: "2",
      name: "Cheque",
    },
    {
      id: "3",
      name: "Cash",
    },

    {
      id: "4",
      name: "Pre-Authorized Debit",
    },
    {
      id: "5",
      name: "Credit card",
    },
  ]




    return { first_name,
        middle_name,
        last_name,
        username,
        email,
        phone_number,
        address,
        apartment,
        city,
        province,
        country,
        postal_code,
        profile_image,
        status,
        AssignsData,
        worker_roles,
        nsf,
        internet,
        locker,
        parking,
        advance_rent,
        key_deposit,
        laundry_deposit,
        building_id,
        unit_id,
        taxInfo,
        unit_type,
        monthly_rent,
        lease_start_date,
        lease_end_date,
        hydroInvoices ,
        managerBuildingAssigns,
        buildinglist,
        unitlist,
        unitdetails,
        searchKeywords,
        errorMessage,
        loading,
        makeUrl ,
        searchBuilding,
        countryList, stateList ,
        designation,
        show, profileState,dispatch,handleShow,handleClose,profileId,validation,paymentOption,payment_mode}
}

export default useProfileForm